"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mapInboxRuleToInboxRuleClauses_1 = require("./helpers/mapInboxRuleToInboxRuleClauses");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Sets the given rule to edit mode
 * @param inboxRuleId the inbox rule id
 */
exports.default = legacy_1.select({
    listOptionState: function () { return store_1.default.inboxRulesListState; },
    editOptionState: function () { return store_1.default.inboxRulesEditState; },
})(legacy_1.action('editInboxRule')(function editInboxRule(inboxRuleId, state) {
    var listOptionState = state.listOptionState;
    var inboxRule = listOptionState.inboxRules.get(inboxRuleId);
    mapInboxRuleToInboxRuleClauses_1.default(inboxRule);
}));
//# sourceMappingURL=editInboxRule.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/editInboxRule.js
// module id = 5165
// module chunks = 2